import React from 'react';

export default function Block({ eyebrow, title, intro, children, tinted = false }) {
  return (
    <section className={`px-[6vw] py-[80px] ${tinted ? 'bg-cream-soft/50' : ''}`}>
      <div className="max-w-container-narrow mx-auto">
        {eyebrow && <div className="text-eyebrow uppercase tracking-wider text-gold font-medium mb-3">{eyebrow}</div>}
        <h2 className="font-serif text-warm-black mb-5 max-w-[780px]">{title}</h2>
        {intro && <p className="text-body-l text-muted mb-10 max-w-reading">{intro}</p>}
        {children}
      </div>
    </section>
  );
}